<template>
	<div>
		<div class="pd30">
			<div>
				<a-button type="primary" icon="plus" @click="addProjectAct()">添加模板</a-button>
			</div>
			<div class="form-search-box ">
				<a-form layout="inline">
					<a-form-item label="项目简称">
						<a-input v-model="search.abbreviation" placeholder="请输入项目简称"></a-input>
					</a-form-item>

					<a-form-item label="项目分类">
						<div>
							<a-select style="width: 120px" placeholder="全部分类" v-model="search.project_type_id">
								<a-select-option :value="0">全部分类</a-select-option>
								<a-select-option :value="item.project_type_id" :key="index" v-for="(item,index) in type_list">{{item.name}}</a-select-option>
							</a-select>
						</div>
					</a-form-item>
					
					<!-- <a-form-item label="销量">
						<a-input v-model="search.bg_take_count" style="width: 80px"></a-input>
						-
						<a-input v-model="search.end_take_count" style="width: 80px"></a-input>
					</a-form-item> -->
					<a-form-item>
						<a-button @click="searchAct" type="primary">查询</a-button>
						<a-button @click="cancelAct" class="ml10">取消</a-button>
					</a-form-item>
				</a-form>
			</div>

			<div class="">
				<div class="wxb-table-gray">
					<a-table rowKey="project_id" :columns="columns" :pagination="pagination" @change="handleTableChange"
						:data-source="datas" :loading="loading">
						
						<div class="flex alcenter center" slot="project_slot" slot-scope="record">
							<img :src="record.cover_img"  class="projetc-index-cover-img" />
							<div class="ml5" style="text-align: left;">
								<div>{{record.abbreviation}}</div>
							</div>
						</div>
						
						<div class="flex alcenter center" slot="type_slot" slot-scope="type,record">
							{{type != null ? type.name : '暂无分类'}}
						</div>
						
						<div class="flex alcenter center" slot="market_price_slot" slot-scope="market_price,record">
							¥{{market_price}}
						</div>

						<div class="flex alcenter center" slot="expert_price_slot" slot-scope="expert_price,record">
							¥{{expert_price}}
						</div>

						<div class="flex alcenter center" slot="master_price_slot" slot-scope="master_price,record">
							¥{{master_price}}
						</div>

						<template slot="status_slot" slot-scope="status,record">
							<div v-if="status == 1">未发布</div>
							<div v-if="status == 2">已发布</div>
							<div v-if="status == 3">已失效</div>
						</template>

						<template slot="action" slot-scope="record,index">
							<div class="flex center">
								<a-dropdown placement="bottomRight">
									<span class="more-act">
										<i class="iconfont iconmore_gray"></i>
									</span>
									<a-menu slot="overlay">
										<a-menu-item>
											<a class="menu-act" href="javascript:;" @click="editProjectAct(record)">
												<i class="iconfont ft14 iconedit"></i>
												<span class="ml10">编辑</span>
											</a>
										</a-menu-item>
										<a-menu-item>
											<a class="menu-act" href="javascript:;" @click="delProjectAct(record)">
												<i class="iconfont ft14 icondelete"></i>
												<span class="ml10">删除</span>
											</a>
										</a-menu-item>

									</a-menu>
								</a-dropdown>
							</div>
						</template>
					</a-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {listMixin} from '../../../../common/mixin/list.js';
	export default{
		mixins: [listMixin],
		data(){
			return{
				loading: false,
				pagination: {
					current: 1,
					pageSize: 10, //每页中显示10条数据
					total: 0,
				},
				type_list:[],
				search:{
					abbreviation:'',
					project_type_id:0,
					bg_take_count: '',
					end_take_count: '',
				},
				columns: [
					{title: '模板ID',dataIndex: 'template_id',align: 'center'},
					{title: '模板名称',dataIndex: 'name',align: 'center'},
					{title: '项目名称',key: 'project',align: 'center',width:300,scopedSlots: {customRender: 'project_slot'}},
					{title: '所属分类',dataIndex: 'type',align: 'center',scopedSlots: {customRender: 'type_slot'}},
					{title: '资深治疗师价',dataIndex: 'market_price',align: 'center',scopedSlots: {customRender: 'market_price_slot'}},
					{title: '总监治疗师价',dataIndex: 'expert_price',align: 'center',scopedSlots: {customRender: 'expert_price_slot'}},
					{title: '专家治疗师价',dataIndex: 'master_price',align: 'center',scopedSlots: {customRender: 'master_price_slot'}},
					{title: '状态',dataIndex: 'status',align: 'center',scopedSlots: {customRender: 'status_slot'}},
					{title: '创建时间',dataIndex: 'add_time_format',align: 'center',ellipsis: true},
					{title: '操作',key: 'action',align: 'center',scopedSlots: {customRender: 'action'}}
				],
				datas: [],
			}
		},
		methods:{
			getLists(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/getTemplateList',{
					limit:this.pagination.pageSize,
					page:this.pagination.current,
					abbreviation:this.search.abbreviation,
					project_type_id:this.search.project_type_id,
					bg_take_count:this.search.bg_take_count,
					end_take_count:this.search.end_take_count,
				}).then(res=>{
					this.pagination.total=res.total;
					this.datas=res.list;
					if(res.type_list){
						this.type_list=res.type_list;
					}
					this.loading=false;
				}).catch(res=>{
					this.loading=false;
				})
			},
			
			delProjectAct(record){
				this.$confirm({
					title:'确认删除这个模板吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('admin/delTemplate',{
								template_id:record.template_id,
							}).then(res=>{
								this.$message.success('删除成功',1,()=>{
									this.getLists();
								});
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
			
			addProjectAct(){
				this.$router.push('/template/edit');
			},
			editProjectAct(record){
				this.$router.push('/template/edit?id='+record.template_id);
			},
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current;
				this.getLists();
			},
		}
	}
</script>

<style>
	.projetc-index-cover-img{
		width: 80px;
		height: 60px;
	}
</style>
